export default __webpack_public_path__ + "static/media/csv.d249dd16.png";